import { useThrottleFn } from '@vueuse/core'
import { breakpoints } from '~/utils/breakpoints'

export default defineNuxtPlugin(() => {
  const deviceHint = useCookie<string | null>('ta_device', {
    sameSite: 'lax',
    maxAge: 60 * 60 * 24 * 30,
  })

  const updateHint = () => {
    const isMobile = window.matchMedia(`(max-width: ${breakpoints.screen_laptop - 1}px)`).matches
    deviceHint.value = isMobile ? 'm' : 'd'
  }

  updateHint()

  const onResize = useThrottleFn(updateHint, 250)
  window.addEventListener('resize', onResize, { passive: true })
  window.addEventListener('orientationchange', onResize, { passive: true })
})

